import { z } from 'zod';
import type { SearchKind } from '@/mock';

const SEARCH_KINDS = ['task', 'message', 'person', 'channel', 'project', 'doc'] as const satisfies readonly SearchKind[];

export const searchRequestSchema = z.object({
  text: z.string().min(1).max(200),
  kinds: z.array(z.enum(SEARCH_KINDS)).min(1),
  scope: z
    .object({
      channelId: z.string().optional(),
      projectIds: z.array(z.string()).optional(),
    })
    .optional(),
  limit: z.number().int().min(1).max(100),
});

export const searchResponseSchema = z.object({
  hits: z.array(z.object({ kind: z.enum(SEARCH_KINDS), id: z.string() })),
});

export const SEARCH_ERROR_STATUS = {
  'invalid-request': 400,
  unauthenticated: 401,
  'search-unavailable': 503,
} as const;

export type SearchRequestBody = z.infer<typeof searchRequestSchema>;
export type SearchResponseBody = z.infer<typeof searchResponseSchema>;
export type SearchErrorCode = keyof typeof SEARCH_ERROR_STATUS;
